import React from 'react';
import { CONTROL_RENDERERS } from './renderers';

import type { IBaseProps } from '@home/types/common';
import type { IDynamicFormFieldType, IDynamicFormControl } from './types';

interface IDynamicFormControlProps extends IBaseProps {
  type: IDynamicFormFieldType;
  label?: string;
  control: IDynamicFormControl;
  value: any;
  onChange?: (payload?: any) => void;
  onFocus?: (e?: any) => void;
  onBlur?: (e?: any) => void;
}

const DynamicFormControl: React.FC<IDynamicFormControlProps> = (props) => {
  const {
    type,
    label,
    control,
    value,
    onChange,
    onFocus,
    onBlur,
    generateCustomizeAddOptionDataHandle,
    generateCustomizeDeleteOptionDataHandle,
  } = props;

  const render = CONTROL_RENDERERS[type];

  return (
    render?.({
      ...control,
      label,
      value,
      onChange,
      onFocus,
      onBlur,
      generateCustomizeAddOptionDataHandle,
      generateCustomizeDeleteOptionDataHandle,
    } as any) || null
  );
};

export default DynamicFormControl;
